import { getAxiosOptions } from "../../../services/serviceHelper";
import { getRowNumbersOfTableInDB } from "../../../utility/dataEntry/formData";

export const reviewStatus = (reviewData, subField) => {
  if (reviewData && reviewData.hasOwnProperty(`r_${subField?.id}`)) {
    return { haveReview: true, resolved: !!reviewData[`r_${subField?.id}`] };
  } else {
    return { haveReview: false };
  }
};

export const isHidden = (hiddenTableIds, subField) => {
  return (
    hiddenTableIds &&
    hiddenTableIds.includes(parseInt(subField?.id.split("__")[0]))
  );
};

export const getColor = (reviewData, subField) => {
  const resolvedStatus = reviewStatus(reviewData, subField);
  return resolvedStatus.haveReview
    ? resolvedStatus.resolved
      ? "green"
      : "red"
    : "";
};

export const getValueForListData = async (
  user,
  processId,
  field,
  allPreviewValue,
  listData,
  getValueForPlaceholder
) => {
  let valueObj = {};
  const subFieldPattern = `f_${field.subfield_template_ids.split(",")[0]}__`;
  const rows = await getRowNumbersOfTableInDB(
    processId,
    subFieldPattern,
    getAxiosOptions(user)
  );
  for (let i = 0; i < rows.length; i++) {
    for (let subField of field.subFields[0]) {
      let listDataId =
        allPreviewValue["f_" + subField.id.split("__")[0] + "__" + rows[i]];
      for (let listDatum of listData) {
        if (listDatum.id == listDataId) {
          let value = listDatum.value;
          let fieldKey = "f_" + subField.id.split("__")[0] + "__" + rows[i];
          let alteredValue = await getValueForPlaceholder(
            fieldKey,
            value,
            processId
          );
          valueObj = { ...valueObj, [fieldKey.split("f_")[1]]: alteredValue };
        }
      }
    }
  }
  return valueObj;
};
